<template>
  <div className="documents-page">
    <iframe
      :src="iframeSrc"
      frameborder="0"
    />
  </div>
</template>

<script>
import {useRoute} from 'vue-router/dist/vue-router'
import {computed, onMounted, onUnmounted} from 'vue'

export default {
  name: 'ContactPage',
  setup() {
    const route = useRoute()

    const handleMessage = (event) => {
      if (event.origin === 'https://calc.apex-tech.ru' && event.data.type === 'open-personal-data-policy') {
        try {
          window.open('/privacy_policy.pdf', '_blank');
        } catch(e) {
          console.error('Возникла проблема с открытием файла privacy_policy.pdf')
        }
      }
    }

    const iframeSrc = computed(() => {
      const url = new URL(`https://calc.apex-tech.ru/iframe/contacts/?color=%23e42c31&locationGuid=ebcb9168-70a1-11ed-ae68-ac1f6b447939`)
      Object.entries(route.query || {}).forEach(([key, value]) => {
        url.searchParams.set(key, value.toString())
      })
      return url.href
    })

    onMounted(() => {
      window.addEventListener('message', handleMessage);
    })

    onUnmounted(() => {
      window.removeEventListener('message', handleMessage);
    })

    return {
      iframeSrc
    }
  }
}
</script>

<style scoped>
.documents-page {
  background-color: #f9f9f9;
}

iframe {
  height: calc(100vh - 110px);
  max-width: 100%;
  width: 100%;
}

@media screen and (max-width: 768px) {

}
</style>
